/* eslint-disable sort-keys-fix/sort-keys-fix */
import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData } from "./types"

const S3_PREFIX = "https://media.werz.at/community-assets/missdreamz/"

const MISS_DREAMZ: CommunityData = {
  code: "missdreamz",
  inviteCode: "missdreamz",
  name: "Miss Dreamz",
  thumbnail: "",
  favicon: "",
  defaultCurrency: "EUR",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/miss-030`,
  waitlist: false,
  socials: {},
  styles: {
    comingSoon: {
      bgColor: "#000000",
      hero: {
        desktop: `https://media.werz.at/community-assets/missdreamz/mobile-landing-background.mp4?type=video`,
        mobile: `https://media.werz.at/community-assets/missdreamz/mobile-landing-background.mp4?type=video`,
        style: "bg-[#222222]",
      },
      logo: {
        desktop: `${S3_PREFIX}web-alternative-logo.png`,
        mobile: `${S3_PREFIX}web-alternative-logo.png`,
        style: "w-[92px] h-[71px] sm:w-[160px] sm:h-[123px]",
      },
      werzLogoColor: "#FFFFFF",
      title:
        "font-['AcuminProUltraBlackItalic'] text-[28px] leading-[120%] text-[#ff007e] uppercase",
      text: "font-['AcuminProRegular'] text-[16px] leading-[120%] text-[#ff007e]",
      button:
        "font-['AcuminProExtraCondensedUltraBlackItalic'] text-[22px] leading-[120%] p-4 bg-[#ff007e] text-[#000000] cursor-pointer w-fit",
      input: {
        base: "font-['AcuminProRegular'] text-[14px] leading-[120%] w-[256px] px-4 h-[48px] bg-[#222222] text-[#ffffff]",
        border: "#444444",
        borderFocus: "#6d6d6d",
        borderError: "#FF0000",
        errorText: "text-[#FF0000]",
      },
      error: "font-['AcuminProRegular'] text-[14px] leading-[120%] text-[#FF0000]",
      footerText: "font-['AcuminProRegular'] text-[14px] leading-[120%] text-[#6d6d6d]",
      skipButton:
        "font-['AcuminProRegular'] text-[14px] leading-[120%] text-[#6d6d6d] cursor-pointer",
      modal: {
        container: "bg-[#222222] px-[40px] py-[48px]",
        title:
          "font-['AcuminProUltraBlackItalic'] text-[24px] leading-[120%] text-[#ff007e] text-center",
        text: "font-['AcuminProRegular'] text-[14px] leading-[120%] text-[#6d6d6d] text-center",
        width: "w-[358px]",
        backdrop: "bg-black/50",
        otpInput:
          "!w-[40px] !h-[50px] rounded-[4px] text-[#ffffff] bg-[#000000] font-['AcuminProRegular'] text-[16px] leading-[120%] text-center",
        otpBorder: "#444444",
        otpBorderFocus: "#6d6d6d",
      },
    },
    global: {
      werzLogoColor: "#FFF",
      counterColor: "#FFF",
      logo: {
        src: "https://media.werz.at/community/icon/cmmkthug800009kjsp4zez97j.jpg?uploadTime=1773348408061&type=image",
        styles: "w-[96px] h-[96px] object-contain",
      },
      alternativeLogo: {
        src: `${S3_PREFIX}web-alternative-logo.png`,
        styles: "w-[160px] h-[123px]",
      },
      modalWindow: {
        container: "",
        title: "",
        subtitle: "",
      },
      bgColor: "#000000",
      asideBg: "#000000",
      asideStyles: "border-r border-[#444444]",
      contentBg: "",
      contentBoxShadow: "",
      bgDesktop: `${S3_PREFIX}web-background.png`,
      bgMobile: `${S3_PREFIX}web-background-mobile.png`,
      nonMemberBg: `${S3_PREFIX}web-background-non-member.png`,
      mainFont: "font-['AcuminProRegular']",
      primaryButton:
        "bg-[#ff007e] rounded-[6px] px-[12px] py-[12px] !text-[#000000] font-['AcuminProExtraCondensedUltraBlackItalic'] !text-[22px] text-left",
    },
    navigation: {
      iconsColor: "#ffffff",
      sideBarSeparator: "border-r-[1px] border-[#444444]",
      separator: "border-[#444444]",
      item: "font-['AcuminProExtraCondensedUltraBlackItalic'] text-[20px] text-[#ffffff] uppercase text-left gap-x-[10px] text-opacity-50 text-center border-b border-[#444444] !pl-0 !py-3",
      itemSelected: " !text-opacity-100",
    },
    communityLanding: {
      container: "!bg-[#000000] border border-[#444444] !pb-8",
      titles: "text-[#ff007e] font-['AcuminProUltraBlackItalic'] text-[40px] uppercase text-left",
      emptyOrLoadingState:
        "!mx-4 sm:!mx-8 text-[#ffffff] font-['AcuminProRegular'] text-[14px] text-left leading-[120%]",
      announcementsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b border-[#444444]",
        sectionTitle:
          "!text-[#ff007e] !font-['AcuminProUltraBlackItalic'] text-[40px] uppercase text-left pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container: "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 gap-x-4",
          wrapper: "relative group",
          item: "w-fit",
        },
        item: {
          container:
            "min-w-[calc(100vw-48px)] sm:min-w-[256px] sm:max-w-[256px] overflow-hidden bg-[#ffffff00]",
          mediaContainer: "w-full sm:w-[256px] !aspect-square relative",
          media: "w-full !aspect-square object-cover",
          placeholderMedia: "w-full !aspect-square bg-gray-400",
          content: "flex flex-col py-4 bg-transparent",
          title:
            "text-[#ff007e] font-['AcuminProUltraBlackItalic'] text-[16px] uppercase text-left leading-[110%]",
          subtitle:
            "text-[#ffffff] font-['AcuminProRegular'] text-[14px] text-left leading-[120%] mt-2",
        },
      },
      eventsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b border-[#444444]",
        sectionTitle:
          "text-[#ff007e] font-['AcuminProUltraBlackItalic'] text-[40px] uppercase text-left pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container:
            "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 !h-full sm:!h-[128px] flex-row gap-6",
          wrapper: "relative group w-full",
          item: "w-fit",
        },
        item: {
          container:
            "flex sm:flex-row flex-col w-[calc(100vw-56px)] sm:!w-[428px] h-full overflow-hidden bg-[#ffffff00]",
          mediaContainer: "w-full sm:!w-[228px] sm:flex-shrink-0 relative",
          media: "w-full !aspect-video object-cover",
          placeholderMedia: "w-full !aspect-video bg-gray-400",
          content: "flex flex-col px-4 bg-transparent",
          title:
            "text-[#ff007e] font-['AcuminProUltraBlackItalic'] text-[16px] uppercase text-left leading-[110%]",
          subtitle:
            "text-[#ffffff] font-['AcuminProRegular'] text-[12px] text-left leading-[120%] mt-2",
          location:
            "text-[#ffffff] font-['AcuminProRegular'] text-[12px] text-left leading-[120%] mt-1",
          date: "text-[#ffffff] font-['AcuminProRegular'] text-[12px] text-left leading-[120%] mt-2",
        },
      },
      shop: {
        container: "py-4 sm:py-8 !pb-16 !m-0 space-y-0 !border-0 overflow-hidden",
        title:
          "text-[#ff007e] font-['AcuminProUltraBlackItalic'] text-[22px] uppercase text-left leading-[110%]",
        text: "text-[#ff007e] font-['AcuminProRegular'] text-[16px] text-left leading-[120%]",
        customShopImageStyle: "",
        sectionTitle:
          "text-[#ff007e] font-['AcuminProUltraBlackItalic'] text-[40px] uppercase text-left !mb-4 sm:mb-6",
      },
    },
    linktree: {
      bgDesktop: "https://media.werz.at/community-assets/missdreamz/web-background-non-member.png",
      bgMobile: "https://media.werz.at/community-assets/missdreamz/web-background-non-member.png",
      bgColor: "#000000",
      bgMedia: "object-cover object-center",
      container:
        "flex flex-col items-center h-full w-full bg-center bg-cover bg-no-repeat min-h-screen relative px-4 py-12 sm:p-[64px] bg-[#000000]",
      communityInfo: {
        logo: "h-[128px] w-[128px] rounded-full border border-[2.5px] object-cover border border-[#444444]",
        name: "text-[#ff007e] font-['AcuminProUltraBlackItalic'] text-[26px] uppercase leading-[28.6px] text-center text-center mt-4 mb-1",
        location:
          "font-['AcuminProUltraBlackItalic'] uppercase leading-[19.8px] text-[16px] text-center text-center mb-2",
        description:
          "text-[#ff007e] font-['AcuminProRegular'] text-[16px] leading-[120%] text-center text-center mb-4 max-w-[500px]",
        socialMediaIconColor: "#FFF",
        button:
          "bg-[#000000] border border-[#ffffff] rounded-[6px] px-[12px] py-[8px] text-[#ffffff] font-['AcuminProExtraCondensedUltraBlackItalic'] text-[18px] text-left w-fit cursor-pointer",
      },
      upcomingEvents: {
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center bg-[#000000] border border-[#444444] text-[#ff007e] font-['AcuminProRegular'] text-[16px] leading-[120%] text-center",
        emptyState: {
          container:
            "sm:w-[500px] w-[95vw] flex flex-col justify-center items-center p-[34px] mb-[32px] bg-[#000000] border border-[#444444]",
          title:
            "font-['AcuminProUltraBlackItalic'] uppercase leading-[19.8px] text-[16px] text-left text-center mb-1",
          text: "text-[#ff007e] font-['AcuminProRegular'] text-[16px] leading-[120%] text-center text-center",
          button:
            "bg-[#000000] border border-[#ffffff] rounded-[6px] px-[12px] py-[8px] text-[#ffffff] font-['AcuminProExtraCondensedUltraBlackItalic'] text-[18px] text-left w-fit cursor-pointer mt-4",
        },
        header:
          "text-[#ff007e] font-['AcuminProUltraBlackItalic'] uppercase leading-[19.8px] text-[16px] text-left text-center mb-[10px]",
        container: "sm:w-[500px] w-[95vw] gap-4 flex flex-col items-center overflow-hidden",
        collapsedEvent: {
          container:
            "h-[64px] cursor-pointer sm:w-[500px] w-[95vw] flex justify-between bg-[#000000] border border-[#444444]",
          duration:
            "text-[#ffffff] font-['AcuminProRegular'] text-[12px] leading-[14.4px] text-left",
          name: "text-[#ff007e] font-['AcuminProUltraBlackItalic'] uppercase leading-[19.8px] text-[16px] text-left one-line-truncate sm:w-[390px] w-[65vw]",
          plusIconColor: "#FFF",
          media: "overflow-hidden m-2 border border-[#444444]",
        },
        event: {
          container: "overflow-hidden sm:w-[500px] w-[95vw] bg-[#000000] border border-[#444444]",
          name: "text-[#ff007e] font-['AcuminProUltraBlackItalic'] uppercase leading-[19.8px] text-[16px] text-left mb-1 one-line-truncate sm:w-[370px] w-[60vw]",
          startDate:
            "w-[68px] h-[68px] flex flex-col justify-center items-center gap-1 bg-[#ffffff] border border-[#444444] rounded-[6px] text-[#000000] font-['AcuminProUltraBlackItalic'] text-[16px] uppercase leading-[17.6px] text-center",
          duration:
            "text-[#ffffff] font-['AcuminProRegular'] text-[12px] leading-[14.4px] text-left",
          location:
            "text-[#ffffff] font-['AcuminProRegular'] text-[12px] leading-[14.4px] text-left",
          button:
            "bg-[#000000] border border-[#ffffff] rounded-[6px] px-[12px] py-[8px] text-[#ffffff] font-['AcuminProExtraCondensedUltraBlackItalic'] text-[18px] text-left w-fit cursor-pointer mt-3",
          product: {
            container:
              "min-h-[68px] px-4 py-3 flex justify-between gap-4 border-t border-[#444444]",
            name: "text-[#ff007e] font-['AcuminProUltraBlackItalic'] uppercase leading-[17.6px] text-[14px] text-left one-line-truncate sm:w-[390px] w-[65vw]",
            price:
              "text-[#ff007e] font-['AcuminProUltraBlackItalic'] uppercase leading-[17.6px] text-[14px] text-left",
            link: "text-[#ffffff] font-['AcuminProRegular'] text-[14px] leading-[16.8px] text-left",
            status:
              "text-[#ff007e] font-['AcuminProUltraBlackItalic'] uppercase leading-[110%] text-[14px] text-left",
            button:
              "bg-[#000000] border border-[#ffffff] rounded-[6px] px-[12px] py-[8px] text-[#ffffff] font-['AcuminProExtraCondensedUltraBlackItalic'] text-[18px] text-left w-fit cursor-pointer",
          },
        },
        seeAllEvents:
          "text-[#ff007e] font-['AcuminProRegular'] text-[16px] leading-[120%] text-center text-center mt-4 cursor-pointer mb-[32px] underline",
      },
      news: {
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center bg-[#000000] border border-[#444444] text-[#ff007e] font-['AcuminProRegular'] text-[16px] leading-[120%] text-center",
        header:
          "text-[#ff007e] font-['AcuminProUltraBlackItalic'] uppercase leading-[19.8px] text-[16px] text-left text-center mb-[10px]",
        container: "flex flex-col gap-4",
        oneNews: {
          container:
            "h-[64px] cursor-pointer sm:w-[500px] w-[95vw] flex justify-between bg-[#000000] border border-[#444444]",
          name: "text-[#ff007e] font-['AcuminProUltraBlackItalic'] uppercase leading-[19.8px] text-[16px] text-left one-line-truncate sm:w-[390px] w-[65vw]",
          triangleIconColor: "#FFF",
          created:
            "text-[#ffffff] font-['AcuminProRegular'] text-[12px] leading-[14.4px] text-left",
          media: "overflow-hidden m-2 border border-[#444444]",
        },
        seeAllNews:
          "text-[#ff007e] font-['AcuminProRegular'] text-[16px] leading-[120%] text-center text-center mt-4 cursor-pointer mb-[32px] underline",
      },
      radioTracks: {
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center bg-[#000000] border border-[#444444] text-[#ff007e] font-['AcuminProRegular'] text-[16px] leading-[120%] text-center",
        header:
          "text-[#ff007e] font-['AcuminProUltraBlackItalic'] uppercase leading-[19.8px] text-[16px] text-left text-center mb-[10px]",
        container: "flex flex-col gap-4",
        radioTrack: {
          container:
            "h-[64px] cursor-pointer sm:w-[500px] w-[95vw] flex justify-between bg-[#000000] border border-[#444444]",
          coverUrl: "overflow-hidden m-2 border border-[#444444]",
          duration:
            "text-[#ffffff] font-['AcuminProRegular'] text-[12px] leading-[14.4px] text-left",
          liveType:
            "text-[#ffffff] font-['AcuminProRegular'] text-[12px] leading-[14.4px] text-left",
          liveTypeCircle: "w-2 h-2 bg-[#ff007e] rounded-full",
          playIconColor: "#000000",
          playIconBackgroundColor: "#ff007e",
          playIconBorderColor: "#000000",
          start: "text-[#ffffff] font-['AcuminProRegular'] text-[12px] leading-[14.4px] text-left",
          title:
            "text-[#ff007e] font-['AcuminProUltraBlackItalic'] uppercase leading-[19.8px] text-[16px] text-left one-line-truncate sm:w-[390px] w-[65vw]",
        },
        seeAllTracks:
          "text-[#ff007e] font-['AcuminProRegular'] text-[16px] leading-[120%] text-center text-center mt-4 cursor-pointer mb-[32px] underline",
      },
      otherLinks: {
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center bg-[#000000] border border-[#444444] text-[#ff007e] font-['AcuminProRegular'] text-[16px] leading-[120%] text-center",
        header:
          "text-[#ff007e] font-['AcuminProUltraBlackItalic'] uppercase leading-[19.8px] text-[16px] text-left text-center mb-[10px]",
        container: "flex flex-col gap-[10px] mb-[40px]",
        link: {
          container:
            "h-[64px] cursor-pointer p-2 sm:w-[500px] w-[95vw] flex justify-between bg-[#000000] border border-[#444444]",
          name: "text-[#ff007e] font-['AcuminProUltraBlackItalic'] uppercase leading-[19.8px] text-[16px] text-left",
          triangleIconColor: "#FFF",
          circleIcon: "ml-2 w-[24px] h-[24px] rounded-full object-cover border border-[#444444]",
        },
      },
      footer: {
        WERZlogoColor: "#ffffff",
        text: "text-[#ffffff] font-['AcuminProRegular'] text-[12px] leading-[14.4px] text-left",
      },
    },
    eventV2: {
      container: "flex flex-col !bg-[#000000] border border-[#444444] !pb-8",
      eventInfo: {
        container: "flex flex-col sm:flex-row gap-4 sm:gap-6 sm:p-8 p-4 border-b border-[#444444]",
        media: "sm:!w-[320px] !w-full !h-[180px] object-cover sm:mb-4 !border-0",
        title:
          "text-[#ff007e] font-['AcuminProUltraBlackItalic'] text-[26px] uppercase text-left leading-[110%]",
        subtitle:
          "text-[#ffffff] font-['AcuminProRegular'] text-[14px] text-left leading-[120%] mb-4 mt-2",
        button:
          "bg-[#ff007e] rounded-[6px] px-[12px] py-[12px] !w-fit mb-4 sm:mb-0 text-[#000000] font-['AcuminProExtraCondensedUltraBlackItalic'] !text-[22px] text-left",
        questions: "text-[14px] text-left leading-[120%] text-[#ffffff]",
      },
      about: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-[#444444]",
        header:
          "text-[#ff007e] font-['AcuminProUltraBlackItalic'] text-[22px] uppercase text-left leading-[110%]",
        text: "text-[#ff007e] font-['AcuminProRegular'] text-[14px] text-left leading-[120%] mb-4 w-full",
      },
      location: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-[#444444]",
        header:
          "text-[#ff007e] font-['AcuminProUltraBlackItalic'] text-[22px] uppercase text-left leading-[110%]",
        text: "text-[#ff007e] font-['AcuminProRegular'] text-[14px] text-left leading-[120%] mb-4 max-w-[652px] w-full",
        map: "w-full h-[206px] overflow-hidden border border-[#444444] gap-y-[10px]",
        mapPinColor: "#ff007e",
        mapStrokeColor: "#ff007e00",
      },
      downloadWERZ: {
        container: "flex flex-col gap-4 sm:p-8 p-4",
        header:
          "text-[#ff007e] font-['AcuminProUltraBlackItalic'] text-[22px] uppercase text-left leading-[110%]",
        text: "text-[#ffffff] font-['AcuminProRegular'] text-[14px] text-left leading-[120%]",
      },
      tickets: {
        header:
          "text-[#ff007e] font-['AcuminProUltraBlackItalic'] text-[22px] uppercase text-left leading-[110%] px-4 sm:px-8 pt-4 sm:pt-8 mb-2 sm:mb-4 flex justify-between items-center",
        outerContainer: "flex flex-col !bg-[#000000] !pb-8",
        innerContainer: "flex flex-col overflow-hidden px-4 sm:px-8",
        accessCode: {
          button:
            "bg-[#000000] border border-[#ffffff] rounded-[6px] px-[12px] py-[8px] text-[#ffffff] font-['AcuminProExtraCondensedUltraBlackItalic'] text-[18px] text-left !w-fit",
        },
        ticket: {
          container:
            "flex flex-row justify-between leading-auto !bg-[#ffffff00] border-b border-[#444444] py-4",
          mediaContainer: "!hidden",
          media: "!hidden",
          name: "text-[#ff007e] font-['AcuminProUltraBlackItalic'] text-[16px] uppercase text-left leading-[110%] mb-1",
          description:
            "text-[#ffffff] font-['AcuminProRegular'] text-[14px] text-left leading-[120%] mb-1 flex flex-row",
          price:
            "text-[#ffffff] font-['AcuminProUltraBlackItalic'] text-[16px] uppercase text-left leading-[110%]",
          quantity:
            "text-[#ffffff] font-['AcuminProExtraCondensedUltraBlackItalic'] text-[18px] text-left",
          status:
            "text-[#ffffff] font-['AcuminProUltraBlackItalic'] text-[16px] uppercase text-left leading-[110%]",
          counterContainer:
            "bg-[#000000] border border-[#ffffff] rounded-[6px] px-[12px] py-[12px] gap-x-[16px] !w-fit !h-10",
          button:
            "bg-[#000000] border border-[#ffffff] rounded-[6px] px-[12px] py-[8px] text-[#ffffff] font-['AcuminProExtraCondensedUltraBlackItalic'] text-[18px] text-left !w-fit",
          plusMinusColor: "#ffffff",
        },
      },
    },
  },
}

export default MISS_DREAMZ
